import { markRaw } from 'vue'

const initialState = () => ({
  locations: [],
  groups: markRaw([]),
  levelSortTypes: {},
  pagination: {},
  status: null,
  selected: null
})

export default initialState
